import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Inject,
  Page,
  Toolbar
} from "@syncfusion/ej2-react-grids";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import './NewMain.css';

import { BASE_URL, deleteCall, get } from "../../Services/Calls";
import { Header, Pagination } from "../../components";
import CreateAddIcon from "../../data/createAddIcon.png";
import { tripsGrid } from "../../data/dummy";

const PAGE_SIZE = 10

const Trips = () => {

  const navigate = useNavigate();
  const selectionSettings = { checkboxOnly: true };
  const toolbarOptions = ["Delete", 'Search'];

  const [tripsData, setTripsData] = useState([]);
  const gridRef = useRef(null);

  const [selectedRecords, setSelectedRecords] = useState([]);

  const [deleteConfirm, setDeleteConfirm] = useState(false);

  const editOptions = { allowEditing: false, allowAdding: true, allowDeleting: true };

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    getTrips(1, '');
  }, []);

  const getTrips = async (page, search) => {
    setLoading(true);
    try {
      const countryId = localStorage.getItem("selectedCountry");
      const skip = (page - 1) * PAGE_SIZE;
      let url = `${BASE_URL}/trips?order=DESC&take=${PAGE_SIZE}&skip=${skip}`;
      const trimmedSearch = search ? search.trim() : '';
      if (trimmedSearch && /^\d+$/.test(trimmedSearch)) {
        // The grid's ID column shows the friendly_id, which isn't part of
        // name/description, so a numeric search matches it exactly instead.
        url += `&friendly_id=${trimmedSearch}`;
      } else if (trimmedSearch) {
        url += `&q=${encodeURIComponent(trimmedSearch)}`;
      }
      if (countryId) url += `&country_id=${encodeURIComponent(countryId)}`;

      const response = await get(url);
      if (response) {
        const total = response.count ?? response.results?.length ?? 0;
        setTripsData(response.results ?? []);
        setTotalPages(Math.ceil(total / PAGE_SIZE) || 1);
        setTotalItems(total);
      }
    }
    catch (ex) {
      alert(ex);
    }
    finally {
      setLoading(false);
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    setSelectedRecords([]);
    getTrips(page, searchTerm);
  };

  const actionBegin = (args) => {
    if (args.requestType === 'searching') {
      args.cancel = true;
      const term = args.searchString || '';
      setSearchTerm(term);
      setCurrentPage(1);
      setSelectedRecords([]);
      getTrips(1, term);
    }
  };

  const toolbarClick = args => {
    switch (args.item.text) {
      case 'Delete':
        args.cancel = true;
        setDeleteConfirm(true);
        break
      default:
        break
    }
  }

  const handleDelete = async () => {
    setLoading(true);
    setDeleteConfirm(false);
    try {
      for (let i = 0; i < selectedRecords.length; i++) {
        await deleteCall(BASE_URL + '/trips/' + selectedRecords[i].id)
      }
      const willEmptyPage = selectedRecords.length >= tripsData.length;
      const targetPage = willEmptyPage && currentPage === totalPages && currentPage > 1 ? currentPage - 1 : currentPage;
      if (targetPage !== currentPage) setCurrentPage(targetPage);
      await getTrips(targetPage, searchTerm);
    }
    catch (ex) {
      alert(ex);
    }
    finally {
      setLoading(false);
    }
  }

  const rowSelected = () => {
    if (gridRef.current) {
      const tempSelectedrecords = gridRef.current.getSelectedRecords();
      setSelectedRecords(tempSelectedrecords);
    }
  }

  const rowDeselected = args => {
    let tempSelectedRecords = [...selectedRecords]
    for (let i = 0; i < tempSelectedRecords.length; i++) {
      if (args.data.length > 1) {
        for (let j = 0; j < args.data.length; j++) {
          if (tempSelectedRecords[i].id === args.data[j].id) {
            tempSelectedRecords.splice(i, 1);
          }
        }
      } else {
        if (tempSelectedRecords[i].id === args.data.id) {
          tempSelectedRecords.splice(i, 1);
        }
      }
    }
    setSelectedRecords(tempSelectedRecords);
  }

  return (
    <div className="m-2 ml-10 mr-10 mt-5 p-2 p-5 bg-white rounded-3xl relative">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-white h-12 w-12 animate-spin"></div>
        </div>
      )}
      <div className="flex justify-between items-center h-20">
        <Header category="" title="Trips" />
        <div style={{ width: 200 }} className="w-100 border flex justify-end items-center mb-8 createBtn" onClick={() => { navigate('/createTrip', { state: { from: 'create', data: {} } }) }}>
          <span>Add New Trip</span>
          <img src={CreateAddIcon} style={{ width: 15, height: 15 }} alt="" />
        </div>
      </div>
      <GridComponent
        dataSource={tripsData}
        editSettings={editOptions}
        toolbar={toolbarOptions}
        allowPaging={false}
        allowSorting
        allowFiltering={false}
        selectionSettings={selectionSettings}
        toolbarClick={toolbarClick}
        actionBegin={actionBegin}
        rowSelected={rowSelected}
        rowDeselected={rowDeselected}
        ref={gridRef}
      >
        <ColumnsDirective>
          {tripsGrid(setLoading).map((item, index) => (

            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject services={[Edit, Toolbar, Page]} />
      </GridComponent>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={onPageChange}
      />
      {deleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: 400,
              height: 200,
              background: '#fff',
              borderRadius: 10,
              padding: '15px 20px'
            }}
          >
            <div
              style={{
                fontSize: 24,
                fontWeight: 'bold',
                color: '#000',
                marginBottom: 15
              }}
            >
              Delete Alert
            </div>
            <div style={{ fontSize: 18, color: '#000', marginBottom: 10 }}>
              {selectedRecords.length > 0 ? "Are you sure you want to delete selected rows." : "Please select at-least one row."}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 20
              }}
            >
              <div
                className='confirmOkBtn'
                onClick={() => {
                  setDeleteConfirm(false)
                }}
              >
                {selectedRecords.length > 0 ? "Cancle" : "Ok"}
              </div>
              {selectedRecords.length > 0 &&
                <div
                  className='confirmOkBtn'
                  onClick={() => {
                    handleDelete()
                  }}
                >
                  Yes
                </div>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Trips;
